function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import React, { Component, useState, useEffect } from 'react';
var urls = {
  image: function image(genome, study, gene) {
    return "https://bar.utoronto.ca/api/efp_image/efp_" + genome + "/" + study + "/Absolute/" + gene;
  },
  app: function app(genome, study, gene) {
    return "https://bar.utoronto.ca/efp_" + genome + "/cgi-bin/efpWeb.cgi?dataSource=" + study + "&mode=Absolute&primaryGene=" + gene;
  },
  studies: function studies(genome) {
    return "https://bar.utoronto.ca/api/efp_image/get_efp_data_source/" + genome;
  },
  logo: 'https://bar.utoronto.ca/bbc_logo_small.gif',
  spinner: 'https://www.sorghumbase.org/static/images/dna_spinner.svg'
};
var browsers = {
  sorghum_bicolor: {
    formatGene: function formatGene(gene) {
      return gene._id.replace('SORBI_3', 'Sobic.');
    },
    genome: 'sorghum'
  },
  arabidopsis_thaliana: {
    formatGene: function formatGene(gene) {
      return gene._id;
    },
    fixStudies: function fixStudies(studies) {
      studies = studies.filter(function (s) {
        return s.value !== 'Klepikova_Atlas';
      });
      studies.unshift({
        value: 'Klepikova_Atlas',
        label: 'Klepikova Atlas'
      });
      return studies;
    },
    genome: 'arabidopsis'
  },
  zea_mays: {
    formatGene: function formatGene(gene) {
      return gene.synonyms[0];
    },
    fixStudies: function fixStudies(studies) {
      studies = studies.filter(function (s) {
        return s.value !== 'Hoopes_et_al_Atlas' && s.value !== 'Hoopes_et_al_Stress';
      });
      studies.unshift({
        value: 'Hoopes_et_al_Stress',
        label: 'Hoopes et. al., Stress'
      });
      studies.unshift({
        value: 'Hoopes_et_al_Atlas',
        label: 'Hoopes et. al., Atlas'
      });
      return studies;
    },
    genome: 'maize'
  },
  glycine_max: {
    formatGene: function formatGene(gene) {
      return gene._id.replace('GLYMA_', 'Glyma.');
    },
    fixStudies: function fixStudies(studies) {
      return studies.filter(function (s) {
        return s.value !== 'soybean_senescence';
      });
    },
    genome: 'soybean'
  },
  oryza_sativa: {
    genome: 'rice',
    formatGene: function formatGene(gene) {
      return gene.MSU_id;
    },
    // <<-- need lookup table from IRGSP ids to LOC_d
    fixStudies: function fixStudies(studies) {
      studies = studies.filter(function (s) {
        return s.value !== 'rice_rma' && s.value !== 'rice_mas';
      });
      studies.unshift({
        value: 'rice_rma',
        label: 'rice rma'
      });
      studies.unshift({
        value: 'rice_mas',
        label: 'rice mas'
      });
      return studies;
    }
  }
};
// special case for subsites that refer to maize b73 as "zea_maysb73"
browsers.zea_maysb73 = browsers.zea_mays;
var ImageLoader = function ImageLoader(props) {
  var _useState = useState(true),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = useState(false),
    error = _useState2[0],
    setError = _useState2[1];
  useEffect(function () {
    setLoading(true);
    setError(false);
    var image = new Image();
    image.src = props.url;
    image.onload = function () {
      setLoading(false);
    };
    image.onerror = function () {
      setLoading(false);
      setError(true);
    };
  }, [props.url]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 20
    }
  }, loading && /*#__PURE__*/React.createElement("img", {
    src: urls.spinner,
    alt: "Loading..."
  }), !loading && !error && /*#__PURE__*/React.createElement("img", {
    style: {
      'max-width': '100%'
    },
    src: props.url
  }), error && /*#__PURE__*/React.createElement("p", null, "Error: Failed to load image"));
};
var BAR = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BAR, _Component);
  function BAR(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      currentStudy: null
    };
    return _this;
  }
  var _proto = BAR.prototype;
  _proto.getStudies = function getStudies(browser) {
    var _this2 = this;
    var genome = browser.genome;
    fetch(urls.studies(genome)).then(function (response) {
      return response.json();
    }).then(function (res) {
      if (res.wasSuccessful) {
        var studies = res.data.sort().map(function (v) {
          return {
            value: v,
            label: v.replace(/_/g, ' ')
          };
        });
        if (browser.hasOwnProperty('fixStudies')) {
          studies = browser.fixStudies(studies);
        }
        _this2.setState({
          studies: studies
        });
      }
    })["catch"](console.error);
  };
  _proto.render = function render() {
    var _this3 = this;
    var gene = this.props.gene;
    var study = this.state.currentStudy;
    var browser = browsers[gene.system_name];
    if (!browser) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, "Can't find eFP browser for ", gene.system_name));
    }
    if (!this.state.studies) {
      this.getStudies(browser);
      return /*#__PURE__*/React.createElement("img", {
        src: urls.spinner,
        alt: "Loading..."
      });
    }
    var efp_gene = browser.formatGene(gene);
    if (!study) {
      study = this.state.studies[0].value;
    }
    return /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 10
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: {
        paddingLeft: 20,
        paddingRight: 10
      }
    }, "Select a study:"), /*#__PURE__*/React.createElement("select", {
      value: study,
      onChange: function onChange(e) {
        return _this3.setState({
          currentStudy: e.target.value
        });
      }
    }, this.state.studies.map(function (s, idx) {
      return /*#__PURE__*/React.createElement("option", {
        key: idx,
        value: s.value
      }, s.label);
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ImageLoader, {
      url: urls.image(browser.genome, study, efp_gene)
    }), /*#__PURE__*/React.createElement("a", {
      style: {
        paddingLeft: 100
      },
      href: urls.app(browser.genome, study, efp_gene)
    }, "Powered by ", /*#__PURE__*/React.createElement("img", {
      src: urls.logo,
      style: {
        maxWidth: 40
      }
    }), " Webservices"));
  };
  return BAR;
}(Component);
export { BAR as default };
export function haveBAR(gene) {
  return browsers.hasOwnProperty(gene.system_name);
}